import { TemplateId } from '@gumtree/shared/src/types/advertising/partnership';
import vipCompactCarMoney from '@gumtree/shared/src/partnerships/partners/vip-compact-carmoney/params-list';
import vipCompactCarMoneyMonthlyPrice from '@gumtree/shared/src/partnerships/partners/vip-compact-carmoney-monthly-price/params-list';
import vipCompactAnyvan from '@gumtree/shared/src/partnerships/partners/vip-compact-anyvan/params-list';
import vipDefaultAnyvan from '@gumtree/shared/src/partnerships/partners/vip-default-anyvan/params-list';
import vipDefaultCarMoney from '@gumtree/shared/src/partnerships/partners/vip-default-carmoney/params-list';
import vipCompactConfused from '@gumtree/shared/src/partnerships/partners/vip-compact-confused/params-list';

export default (templateId: TemplateId) => {
    switch (templateId) {
        case 'vip-default-anyvan':
            return vipDefaultAnyvan;
        case 'vip-compact-carmoney':
            return vipCompactCarMoney;
        case 'vip-compact-carmoney-monthly-price':
            return vipCompactCarMoneyMonthlyPrice;
        case 'vip-compact-anyvan':
            return vipCompactAnyvan;
        case 'vip-default-carmoney':
            return vipDefaultCarMoney;
        case 'vip-compact-confused':
            return vipCompactConfused;
    }
};
